import { Building2, ChartLine, HardHat, Store, Warehouse, Wrench } from 'lucide-react';
import { SectionHeader } from '../SectionHeader';
import { Reveal } from '../Reveal';

const INDUSTRY_ICONS = {
  'Multi-Site Operations': Building2,
  'Facilities and Property Management': Wrench,
  'Manufacturing': HardHat,
  'Warehousing and Logistics': Warehouse,
  'Construction and Engineering': ChartLine,
  'Retail and Service Organisations': Store,
};

// Section 16 — who Foresee is for. Only genuinely supported sectors.
export const ForeseeIndustries = ({ sp }) => (
  <section aria-labelledby="foresee-industries-heading" data-testid="foresee-industries" className="bg-white py-20 sm:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <SectionHeader
        index="16"
        eyebrow="Who It's For"
        title="Built for organisations that need clearer compliance visibility"
        testid="foresee-industries-header"
      />
      <ul className="mt-14 grid gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {(sp.industries || []).map((industry, i) => {
          const Icon = INDUSTRY_ICONS[industry.title] || Building2;
          return (
            <Reveal key={industry.title} delay={(i % 3) * 0.06} className="h-full">
              <li className="flex h-full flex-col rounded-xl border border-slate-200 bg-mist p-6" data-testid={`foresee-industry-${i + 1}`}>
                <span className="flex h-11 w-11 items-center justify-center rounded-lg bg-indigo-600 text-white">
                  <Icon className="h-5 w-5" aria-hidden="true" />
                </span>
                <h3 className="mt-4 text-base font-extrabold tracking-tight text-navy-900">{industry.title}</h3>
                <p className="mt-2 text-sm leading-relaxed text-slate-600">{industry.text}</p>
              </li>
            </Reveal>
          );
        })}
      </ul>
    </div>
  </section>
);
